export default __webpack_public_path__ + "static/biome-simulator-acad03949fe8f7dc67f863f8ef78cc60.png";